import { Controller } from "@hotwired/stimulus";
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class extends Controller {
  static targets = ['video'];

  connect() {
    gsap.registerPlugin(ScrollTrigger);

    this.videoTargets.forEach(video => {
      ScrollTrigger.create({
        trigger: video,
        onEnter: () => video.play(),
        onEnterBack: () => video.play(),
        onLeave: () => video.pause(),
        onLeaveBack: () => video.pause(),
     });
    })
  }
}